module.exports = "<p>\n  roles-list works!\n</p>\n"